import { CardLeadingActionsProps } from "../props/CardLeadingActionsProps"
import { useEffect, useState } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Check } from "phosphor-react-sc";

export const CardLeadingActions = ({
    cardService,
    canAccept,
    canSelect,
    isSelected,
    dispatcherService,
    allowBothSelectAndClick = false,
}: CardLeadingActionsProps) => {

    const [width, setWidth] = useState<number>(0);
    const [className, setClassName] = useState<string>("");
    const [opacity, setOpacity] = useState<number>(0);

    useEffect(() => {
        cardService.onLeadingActionsWidthChange = setWidth;
        cardService.onLeadingActionsClassNameChange = setClassName;
        cardService.onLeadingActionsOpacityChange = setOpacity;
        return (() => {
            cardService.onLeadingActionsWidthChange = () => { };
            cardService.onLeadingActionsClassNameChange = () => { };
            cardService.onLeadingActionsOpacityChange = () => { };
        })
    }, []);

    const handleDivClick = () => {
        dispatcherService.onSelect(!isSelected);
    };

    const handleCheckboxChange = (e: any) => {
        dispatcherService.onSelect(e.value ?? false);
    };

    const handleCheckboxClick = (e: any) => {
        e.stopPropagation();
    };

    return (
        <section
            className={`crd-leading-actions ${cardService.classNameLeadingActions} ${className}`}
            style={{ width: width, opacity: opacity, marginRight: (opacity > 0 && width < cardService.containerWidth) ? 5 : 0 }}>
            {canAccept &&
                <div className={"crd-action crd-leading-actions-accept crd-leading-actions-select-active"} onClick={(e: any) => dispatcherService.onAccept(e)}>
                    <Check className="crd-accept" weight="bold" />
                </div>}
            {canSelect &&
                <div
                    className={`crd-action crd-leading-actions-select  ${isSelected ? "crd-leading-actions-select-active" : ""}`}
                    onClick={allowBothSelectAndClick ? undefined : handleDivClick}>
                    <div className={`crd-leading-actions-select-content`}>
                        <Checkbox
                            checked={isSelected}
                            className="crd-select"
                            onChange={allowBothSelectAndClick ? handleCheckboxChange : undefined}
                            onClick={allowBothSelectAndClick ? handleCheckboxClick : undefined}
                        />
                    </div>
                </div>
            }
        </section>
    )
}